import React from 'react';
import { type IThreeContext, type IThreeContextData, ThreeContext } from '../../../services/ThreeContext';

interface ThreePresentationProps<TState> {
    onStart: (context: IThreeContextData) => TState;
    onUpdate: (context: IThreeContextData, state: TState) => void;
}

function ThreePresentation<TState>(props: ThreePresentationProps<TState>) {

    const [isPending, togglePending] = React.useState<boolean>(true);
    const [progress, setProgress] = React.useState<[number, number]>([0, 1]);

    const [container, setContainer] = React.useState<HTMLDivElement | null>(null);
    const [canvas, setCanvas] = React.useState<HTMLCanvasElement | null>(null);

    const { onStart, onUpdate } = props;

    const context = React.useMemo(
        (): IThreeContext | null => {
            if (canvas === null || container === null) {
                return null;
            }

            const size = container.getBoundingClientRect();
            const threeContext = new ThreeContext(
                canvas,
                container,
                size.width,
                size.height,
                onStart,
                onUpdate,
            );

            return threeContext;
        },
        [canvas, container, onStart, onUpdate]
    );

    React.useEffect(
        () => {
            if (!!context) {
                console.log("Context is mounted!");
            }

            return () => {
                if (!!context) {
                    context.dispose();
                    console.log("Context is unmounted!");
                }
            };
        },
        [context]
    );

    React.useLayoutEffect(
        () => {
            function onWindowResize() {
                if (!!container) {
                    const size = container.getBoundingClientRect();
                    context?.onWindowResize(size.width, size.height);
                }
            }

            window.addEventListener("resize", onWindowResize);

            return () => {
                window.removeEventListener("resize", onWindowResize);
            };
        },
        [container, context]
    );

    return (
        <div ref={(e) => setContainer(e)} style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
        }}>
            {/*isPending && (
                <div>
                    Loading...
                </div>
            )*/}
            <canvas ref={(e) => setCanvas(e)} />
        </div>
    );
};

export default ThreePresentation;